export const shop_list_request_invalid = 'shop_list_request_invalid';
export const shop_list_request_send = 'shop_list_request_send';
export const shop_list_request_valid = 'shop_list_request_valid';
export const shop_select_type = 'shop_select_type';

export function ShopSelectType(type, children) {
    return {
        type: shop_select_type,
        data: {
            type,
            children,
        },
    };
}
